export default "__VITE_ASSET__CMaDfXqU__"